import { format, isToday, isYesterday, differenceInSeconds, parseISO, isSameWeek } from "date-fns";

export function formatNotificationTimestamp(iso) {
  if (!iso) return "Unknown date";

  const date = parseISO(iso.replace(" ", "T"));
  const now = new Date();
  const sec = differenceInSeconds(now, date);

  if (sec < 60) return "Just now";
  if (isToday(date)) return "Today";
  if (isYesterday(date)) return "Yesterday";

  if (isSameWeek(date, new Date())) {
    return format(date, "EEEE");
  }

  const sameYear = now.getFullYear() === date.getFullYear();
  return format(date, sameYear ? "MMM do" : "MMM do, yyyy");
}
